import { useEffect, useState } from "react";
import { ArrowRight, RefreshCw } from "lucide-react";
import { priceHistory, euro } from "@/lib/store";

const FIELD_LABEL = { price_cents: "Prezzo", promo_price_cents: "Prezzo promo" };
const SOURCE_LABEL = { LOCANDINA: "Locandina", COPILOT: "Copilot", IMPORT: "Import" };

const val = (v) => (v == null ? "—" : euro(v));

export default function PriceHistory() {
  const [rows, setRows] = useState([]);
  const load = () => priceHistory().then(setRows).catch(() => {});
  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-4" data-testid="price-history">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="font-mono text-xs uppercase tracking-widest text-zinc-500">Storico modifiche prezzo</h3>
          <p className="mt-1 text-sm text-zinc-400">Ogni cambio prezzo/promo con valore precedente, nuovo, fonte e autore. Gli ordini già creati non sono interessati.</p>
        </div>
        <button data-testid="price-history-refresh" onClick={load} className="flex items-center gap-1.5 rounded-full border border-white/10 px-4 py-2 text-sm text-zinc-200">
          <RefreshCw className="h-4 w-4" /> Aggiorna
        </button>
      </div>

      {rows.length === 0 && <p className="py-8 text-center text-sm text-zinc-500">Nessuna modifica di prezzo registrata.</p>}

      <div className="overflow-x-auto">
        <table className="w-full min-w-[720px] border-separate border-spacing-y-2 text-sm">
          <thead>
            <tr className="text-left text-[11px] uppercase tracking-widest text-zinc-500">
              <th className="px-3">Data</th><th className="px-3">Prodotto</th><th className="px-3">Campo</th>
              <th className="px-3">Variazione</th><th className="px-3">Fonte</th><th className="px-3">Autore</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} data-testid={`price-history-row-${r.id}`} className="bg-[#11141A]">
                <td className="rounded-l-lg px-3 py-2 text-zinc-400">{r.changed_at ? new Date(r.changed_at).toLocaleString("it-IT") : "—"}</td>
                <td className="px-3 py-2">
                  <span className="font-medium text-white">{r.product_name || "—"}</span>
                  {r.variant_label && <span className="ml-1 text-xs text-zinc-500">({r.variant_label})</span>}
                </td>
                <td className="px-3 py-2 text-zinc-300">{FIELD_LABEL[r.field] || r.field}</td>
                <td className="px-3 py-2">
                  <span className="inline-flex items-center gap-1.5">
                    <span className="text-zinc-500 line-through">{val(r.old_value)}</span>
                    <ArrowRight className="h-3 w-3 text-zinc-600" />
                    <span className="font-semibold text-emerald-400">{val(r.new_value)}</span>
                  </span>
                </td>
                <td className="px-3 py-2">
                  {r.source_url ? <a href={r.source_url} target="_blank" rel="noreferrer" className="text-[#2563EB]">{SOURCE_LABEL[r.source] || r.source || "—"}</a>
                    : <span className="text-zinc-400">{SOURCE_LABEL[r.source] || r.source || "—"}</span>}
                </td>
                <td className="rounded-r-lg px-3 py-2 text-zinc-400">{r.actor || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
